import { z } from 'zod';
export const Call_Update_Variables_2_ConfigValidator = z.object({
    source: z
        .object({
        source: z.enum(['custom', 'lastOutboundCall', 'incomingWebhookData'])
    })
        .optional(),
    custom: z.record(z.string(), z.unknown()).optional()
});
//# sourceMappingURL=call-update-variables-2.js.map